<template >
  <div v-if="overallValues">
    <div style="margin:0px 4px;" class="incfont">
      <table class="tbl-table">
        <thead class="tbl-th">
          <tr class="tbl-tr" v-bind:class="{ 'tbl-bg': coloredHeader }">
            <td class="tbl-td tbl-cell" v-bind:style="{ width: getHeadWidth + '%' }"></td>
            <td class="tbl-td tbl-cell bold"
                v-bind:class="{ head15 : waveCount < 5, head10 : waveCount > 4 }"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getHead(index) }}</td>
          </tr>
        </thead>

        <tbody>
        </tbody>

        <tfoot>
          <tr class="tbl-tr" v-bind:class="{ 'tbl-bg': coloredHeader }">
            <td class="tbl-td tbl-cell left">{{$t('Webportal.Dashboard.Total')}}</td>
            <td class="tbl-td tbl-cell bold"
                v-for="(item, index) in overallValues.SurveyWave"
                :key="index">{{ getValue(index, 't') }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShopsOverall',

    props: {
      overallValues: {type: Object, default: null},
      coloredHeader: {type: Boolean, default: true },
    },

    methods: {
      getValue(wave, iwot) {
        let waveItem = this.getWaveItem(wave)
        if (!waveItem)
          return '-'

        if (iwot === 't')
          if (waveItem.NumberOfShopsTotal) return waveItem.NumberOfShopsTotal;

        return '0'
      },

      getWaveItem(index) {
        if (!(_.size(this.overallValues.SurveyWave) > index))
          return undefined

        return this.overallValues.SurveyWave[index]
      },

      hasWaves() {
        return this.overallValues && this.overallValues.SurveyWave && _.size(this.overallValues.SurveyWave) > 0
      },

      getHead(index) {
        if (!(_.size(this.overallValues.SurveyWave) > index))
          return ''
        let item = this.overallValues.SurveyWave[index]
        return item.Name
      }
    },

    computed: {
      getHeadWidth: function() {
        let waves = this.waveCount
        if (waves < 5) return 100 - waves * 15
        return 100 - waves * 10
      },

      waveCount: function () {
        if (!this.hasWaves) return 0
        return _.size(this.overallValues.SurveyWave)
      }
    }
  }
</script>


<style scoped>
td {
  font-size: 9pt;
}
.narrow {
  letter-spacing: -0.15em;
}
.left{
  text-align: left;
}
.bold {
  font-weight: bold;
}
.head10 {
  width:10%;
}

td {
  color:black;
}

</style>
